import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { i18n } from '../../common/locale';
var Avatar = (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, size = _b.size, src = _b.src, style = _b.style, children = _b.children, className = _b.className, mask = _b.mask, useDefaultImage = _b.useDefaultImage, radius = _b.radius, footer = _b.footer, clickable = _b.clickable, frame = _b.frame, frameStyle = _b.frameStyle, frameClassName = _b.frameClassName, rest = __rest(_b, ["prefixCls", "size", "src", "style", "children", "className", "mask", "useDefaultImage", "radius", "footer", "clickable", "frame", "frameStyle", "frameClassName"]);
            var sizeStyle = typeof size === 'number' ?
                { width: size + "px", height: size + "px" }
                : {};
            var avatarCls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-" + size] = typeof size === 'string',
                _a[prefixCls + "-transparent"] = src,
                _a[prefixCls + "-clickable"] = clickable,
                _a[prefixCls + "-with-frame"] = frame,
                _a));
            return (h("span", __assign({}, rest, { className: avatarCls, style: __assign(__assign({ borderRadius: radius }, sizeStyle), style), role: clickable ? 'button' : 'img', "aria-label": mask ? mask : i18n('avatar'), tabIndex: clickable ? 0 : undefined }),
                useDefaultImage || src ?
                    h("span", { className: classNames(prefixCls + "-img"), style: { backgroundImage: src ? "url(\"" + src + "\")" : undefined } })
                    : null,
                children,
                footer && (React.isValidElement(footer) ?
                    h("span", { className: classNames(prefixCls + "-footer") }, footer)
                    : h("span", { className: classNames(prefixCls + "-footer", prefixCls + "-footer-" + footer) })),
                mask ?
                    h("span", { className: classNames(prefixCls + "-mask") }, mask)
                    : null,
                frame && h("div", { className: classNames(prefixCls + "-frame", frameClassName), style: __assign({ backgroundImage: typeof frame === 'string' ? "url(\"" + frame + "\")" : undefined }, frameStyle) }, typeof frame !== 'string' && frame)));
        };
        return _this;
    }
    Avatar.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Avatar;
}(React.Component));
export default Avatar;
Avatar.defaultProps = {
    prefixCls: 'dui-avatar',
    src: '',
    size: 'default',
    mask: '',
    useDefaultImage: true,
    radius: '50%',
    clickable: false,
};
